import { render } from "./QuestionOrderPhraseQuiz.vue?vue&type=template&id=204ca698&scoped=true"
import script from "./QuestionOrderPhraseQuiz.vue?vue&type=script&lang=js"
export * from "./QuestionOrderPhraseQuiz.vue?vue&type=script&lang=js"

import "./QuestionOrderPhraseQuiz.vue?vue&type=style&index=0&id=204ca698&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204ca698"]])

export default __exports__